import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Icon, Input, Col, Row, Modal } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import FormCategorias from './FormCategorias';
import ResponsiveCard from '../Common/ResponsiveCard';
const { confirm } = Modal;

/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class Categorias extends Component {
    state = {
        arrCategorias: [],
        arrCategoriasCopy: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalCategorias: false,
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        this.cargarCategorias();
    }

    /**
     * Función que se ejecuta para cargar las categorías
     */
    cargarCategorias = () => {
        let state = { ...this.state }
        this.setState({ cargando: true }, () => {
            CategoriasRequest.ListarCategorias(true)
                .then(response => {
                    state.arrCategorias = response.data
                    state.arrCategoriasCopy = response.data
                    state.cargando = false
                    this.setState(state)

                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar las categorías",
                        "Error al listar categorías",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrCategoriasCopy = state.arrCategorias
        if (value) {
            arrCategoriasCopy = arrCategoriasCopy.filter(obj => {
                return sanitizerTexto(value, obj.descripcion)
                    || sanitizerTexto(value, obj.tipo_modelo_nombre)
            })
        }
        state.arrCategoriasCopy = arrCategoriasCopy
        this.setState(state);
    }

    /**
     * Función para mostar el modal de categorización
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalCategorias: true })
    }

    /**
     * Función para esconder modal de categorización
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.modalCategorias = false;
        state.categoriaSelected = null;
        this.setState(state)
        if(value) this.cargarCategorias()
    }

    /**
     * Comportamiento al confirmar eliminar clendario
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la categoría?</b> Se borrará la categoría definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-categoria-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-categoria-form',
            },
            onOk: () => {
                this.setState({ cargando: true })
                CategoriasRequest.EliminarCategoria(this.state.categoriaSelected.id)
                    .then(response => {
                        this.setState({categoriaSelected: null})
                        openNotification(
                            "Se ha eliminado correctamente la categoría.",
                            "Categoría eliminada correctamente",
                            true
                        )
                        this.cargarCategorias();
                    })
                    .catch(err => {
                        this.setState({cargando: false})
                        openNotification(
                            err.response.data.cuerpo,
                            "Error al eliminar categoría",
                            false
                        )
                    })
            },
        });
    }

    render() {
        const columnasCategorias = [
            {
                title: "Nombre categoría",
                dataIndex: "descripcion",
                key: "descripcion"
            },
            {
                title: "Tipo modelo",
                dataIndex: "tipo_modelo_nombre",
                key: "tipo_modelo_nombre"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (value, record) => (
                    <div>
                        <div>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Ver detalle"}>
                                    <Button
                                        id="boton-ver-detalle-categoria-row"
                                        icon="eye"
                                        className="btnVerCrearGuardar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: "ver",
                                                tipo_modal: 'uno'
                                            }, this.showModal())
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Editar categoría"}>
                                    <Button
                                        id="boton-editar-categoria-row"
                                        icon="edit"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: "editar",
                                                tipo_modal: 'uno'
                                            }, this.showModal())
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Eliminar categoría"}>
                                    <Button
                                        id="boton-eliminar-categoria-row-modulo-cat"
                                        icon="delete"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record
                                            }, this.showConfirmDelete)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ]

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo categorías"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            type="primary"
                            id="boton-nueva-categoria-modulo"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'dos' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Nueva categoría
                        </Button>
                    </div>
                }>

                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row>
                            <Col span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Nombre / Tipo modelo ">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-categoria-modulo"
                                        placeholder="Buscar por Nombre / Tipo modelo"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={categoria => categoria.id}
                            columns={columnasCategorias}
                            dataSource={this.state.arrCategoriasCopy}
                            pagination={{ showTitle: false }}
                        />
                    </Spin>
                </div>
                <FormCategorias
                    esconderModal={this.esconderModal}
                    visible={this.state.modalCategorias}
                    tipo_modal={this.state.tipo_modal}
                    modo={this.state.modo}
                    detalleCategoria={this.state.categoriaSelected}
                >
                </FormCategorias>
            </ResponsiveCard>
        )
    }
}